import { scopedApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import { DBImportType } from '@/types/import';
import { EndpointResponse } from '@/types/endpoints';
import { utils } from '@/utils';
import type { WriteRequestOptions } from '../requestOptions';

const validate = (importType: string, token: string) => {
  if (!importType) {
    throw new Error('`importType` is required');
  }
  if (!token) {
    throw new Error('`token` is required');
  }
};

type RequestParams = {
  importType: DBImportType;
  token: string;
};

type Response = void;

export const deleteImportPreview = async (
  scope: RequestScope,
  { importType, token }: RequestParams,
  requestOptions: WriteRequestOptions
): Promise<EndpointResponse<Response>> => {
  try {
    validate(importType, token);

    const result = await scopedApi(scope).delete<EndpointResponse<Response>>(`import_preview/${importType}/${token}`, requestOptions);
    return result.data;
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
};
